(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("jszip"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "jszip"], factory);
	else if(typeof exports === 'object')
		exports["react-xlsx"] = factory(require("react"), require("jszip"));
	else
		root["react-xlsx"] = factory(root["react"], root["jszip"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_21__, __WEBPACK_EXTERNAL_MODULE_244__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition